function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 0a2 2 0 012 2v12a2 2 0 01-2 2h-5.09a1 1 0 00-.7.29l-1.49 1.49a.75.75 0 01-.53.22h-.38a.75.75 0 01-.53-.22l-1.49-1.49a1 1 0 00-.7-.29H2a2 2 0 01-2-2V2a2 2 0 012-2h16zm-7.5 12.81l1-1 .304-.302C13 10.328 15 8.354 15 6.75A2.75 2.75 0 0012.25 4 3.2 3.2 0 0010 5a3.18 3.18 0 00-2.25-1A2.75 2.75 0 005 6.75c0 1.534 1.828 3.406 2.994 4.599.164.168.315.323.446.461l1 1a.75.75 0 001.06 0z"
});

var SvgFavoriteComment = function SvgFavoriteComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "#868E96"
  }, props), _ref);
};

export default SvgFavoriteComment;